import React, { useState, useEffect, useMemo } from "react"
import { PolygonAnnotation } from "../../polygonLib"
import Toolbar from "./Toolbar"
import "./polygon.css"
import DisplayCanvas from "../../polygonLib/displayPolygonLib/displayCanvas"

const List = ({
    videoSource,
    // polygonStyle,
    imageSize,
   // showLabel,
    initialPolygons,
    originalSize
  }) => {
    return(
        <>
        {initialPolygons && initialPolygons.length &&
        <DisplayCanvas 
        videoSource={videoSource}
        imageSize={imageSize}
        initialPolygons={initialPolygons}
        originalSize={originalSize}
        actionFrom={'RoiPage'}
        />
    //     <PolygonAnnotation
    //    bgImage={videoSource}
    //    maxPolygons={1}
    //    polygonStyle={polygonStyle}
    //    showLabel={showLabel}
    //    initialPolygonsLength={initialPolygons.length}
    //    initialPolygons={initialPolygons}
    //    whereFrom="list"
    //    imageSize={imageSize}
    //  ></PolygonAnnotation>
        }
        </>
    )
}

export default List;